import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { formatDate } from "../../../utils/utils";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#232F3E",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, details) {
  return { name, details };
}

export default function CustomizedTables(props) {
  const rows = [
    createData("Shift Name:", props.shiftData.shift_name),
    createData("Employee Shift:", props.shiftData.employee_shift),
    createData("Working Hours:", props.shiftData.working_hours),
    createData("Start Time:", props.shiftData.start_time),
    createData("End Time:", props.shiftData.end_time),
    createData("Start Date:", formatDate(props.shiftData.start_date)),
    createData("End Date:", formatDate(props.shiftData.end_date)),
    createData("Mark Late After:", props.shiftData.late_allowed + " minutes"),
    createData(
      "Mark Half Leave After:",
      props.shiftData.half_leave_after + " minutes"
    ),
    createData(
      "Mark Full Leave After:",
      props.shiftData.full_leave_after + " minutes"
    ),
  ];

  return (
    <TableContainer component={Paper} elevation={3} variant="normal" square>
      <Table sx={{ minWidth: 400 }}>
        <TableHead>
          <TableRow>
            <StyledTableCell>Information</StyledTableCell>
            <StyledTableCell align="left"></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="left">{row.details}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}